import React, { useEffect } from "react";
import { Popover } from "@headlessui/react";
import Button from "../Button";
import { DocumentMinusIcon } from "@heroicons/react/24/solid";
import tableIcons from "./MaterialTableIcons";
import { TablePagination } from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  paginationData,
  isPrevPageState,
} from "../../modules/CarrierAgreementMgmt/atoms";
import { useRecoilState } from "recoil";
import { deactivateEmployeeReportsTo } from "../../actions/Utilities/EmployeeReportsTo";
import DeactivateButton from "../DeactivateButton";

const PatchedPagination = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  ...tablePaginationProps
}) => {
  const currentPage = tablePaginationProps.page;
  const [page, setPage] = useRecoilState(paginationData);
  let prevPage = new URLSearchParams(window.location.search).get("prevPage");
  let actionFrom = new URLSearchParams(window.location.search).get(
    "actionFrom"
  );

  const [isPrevPage, setIsPrevPage] = useRecoilState(isPrevPageState);

  useEffect(() => {
    if (actionFrom === null) {
      let initialPage;
      if (prevPage !== null) {
        if (
          !isPrevPage &&
          (Number(prevPage) !== currentPage || Number(prevPage) !== page)
        ) {
          initialPage = currentPage;
        } else {
          initialPage = Number(prevPage);
          setIsPrevPage(false);
        }
      } else {
        initialPage = currentPage;
      }
      setPage(initialPage);
    }
  }, [actionFrom, currentPage, page, prevPage]);

  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      SelectProps={{
        IconComponent: () => <div></div>,
      }}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;

        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
};
const MaterialExTable = ({
  actions,
  columns,
  data = [],
  editable,
  toolbar,
  showTitle = false,
  exportButton,
  grouping,
  search,
  detailPanel,
  selection,
  selectedRows = [],
  onSelectionChange,
  setOpenModal,
  isActive = true,
  paging = true,
  pageSize = 10,
  padding = "dense",
  searchFieldAlignment = "left",
  toolbarButtonAlignment = "right",
  toolBarComponent,
  isLoading = false,
  headerStyle = {
    backgroundColor: "#fff",
    color: "#203A75",
    fontWeight: "bold",
    fontSize: "12px",
  },
  panelWidth,
  tableRef,
  onSearchChange,
  fileName,
  title,
  tableLayout = "auto",
}) => {
  const [page, setPage] = useRecoilState(paginationData);

  return (
    <div className="">
      {selectedRows.length > 0 ? (
        // <Popover className="m-2 rounded-lg">
        <div className="flex justify-start mr-2 pb-2">
          <DeactivateButton
            onClickFunction={() => {
              setOpenModal(true);
            }}
          >
            <DocumentMinusIcon className="h-4 w-4 font-bold " />
            Deactivate
          </DeactivateButton>
          <div className="mt-1 ml-2 text-xs text-primary ">
            Deactivate Selected Row/s
            <p className="inline-block font-bold">
              &nbsp;({selectedRows.length})
            </p>
          </div>
        </div>
      ) : (
        // </Popover>
        ""
      )}
      <MaterialTable
        title={title}
        columns={columns}
        data={data}
        editable={editable}
        actions={actions}
        tableRef={tableRef}
        onSearchChange={onSearchChange}
        initialState={{ page: page }}
        localization={{
          body: {
            emptyDataSourceMessage: isLoading ? (
              <CustomLoader />
            ) : (
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                No records to display.
              </label>
            ),
            addTooltip: "",
            editTooltip: "",
            deleteTooltip: "",
            editRow: {
              cancelTooltip: "",
              saveTooltip: "",
            },
          },
          toolbar: {
            exportTitle: "Export",
            exportAriaLabel: "Export",
          },
        }}
        options={{
          //tableLayout: tableLayout,
          initialPage: page,
          toolbar: isLoading ? false : toolbar,
          showTitle: showTitle,
          padding: padding,
          exportButton: exportButton
            ? { csv: exportButton, pdf: false }
            : false,
          searchFieldAlignment: searchFieldAlignment,
          toolbarButtonAlignment: toolbarButtonAlignment,
          paging: data.length > 0 ? paging : false,
          pageSize: pageSize,
          pageSizeOptions: [10, 15, 20, 30, 100],
          grouping: grouping,
          search: search,
          exportFileName: fileName,
          exportAllData: true,
          headerStyle: headerStyle,
          rowStyle: (rowData) => ({
            backgroundColor: rowData.tableData.showDetailPanel
              ? "#F0F4F5"
              : "#FFF",

            color: "#000000",
            opacity: rowData.tableData.showDetailPanel ? "100" : "20",
            fontWeight: "normal",
            fontSize: "13px",
          }),
          detailPanelType: "single",
          detailPanelColumnStyle: { maxWidth: panelWidth ? panelWidth : 25 },
          selection: selection,
          loadingType: "overlay",
          showTextRowsSelected: false,
          emptyRowsWhenPaging: false,
          selectionProps: isActive
            ? (rowData) => {
                const checked = rowData.tableData.checked
                  ? rowData.status === true ||
                    rowData.isActive === true ||
                    rowData.isActive === "true" ||
                    rowData.isActive === "Active" ||
                    rowData.isInActive === false ||
                    rowData?.status === true
                    ? { checked: true }
                    : { checked: false }
                  : {};
                return {
                  disabled:
                    rowData.isActive === false ||
                    rowData?.status === false ||
                    rowData.isActive === "Inactive" ||
                    rowData.isInActive === true ||
                    rowData.status === "Terminated" ||
                    rowData.isActive === "false" ||
                    rowData.status === "Inactive",
                  ...checked,
                };
              }
            : (rowData) => {
                const checked = rowData.tableData.checked
                  ? rowData.isActive !== "Inactive"
                    ? { checked: true }
                    : { checked: false }
                  : {};
                return {
                  disabled: rowData.isActive === "Inactive",
                  ...checked,
                };
              },
          addRowPosition: "first",
          isFreeAction: true,
          actionsColumnIndex: -1,
        }}
        onSelectionChange={(rows) => {
          onSelectionChange(
            rows.map((r) => {
              const { tableData, ...rows } = r;
              return rows;
            })
          );
        }}
        style={{
          display: "grid",
        }}
        icons={tableIcons}
        detailPanel={detailPanel}
        isLoading={isLoading}
        components={{
          Pagination: PatchedPagination,
          OverlayLoading: () => "",
          Toolbar: (props) =>
            toolBarComponent ? (
              <div className="flex flex-row w-full ">
                {toolBarComponent}
                <div className="w-full">
                  <MTableToolbar {...props} />
                </div>
              </div>
            ) : (
              <div>
                <MTableToolbar {...props} />
              </div>
            ),
        }}
      />
    </div>
  );
};

export default MaterialExTable;
